import React from 'react'
import PropTypes from 'prop-types'

import { PATHS } from 'pages/paths'
import { Home } from 'pages/home'
import { mercadonaDomain, OLD_SHOP_LANGUAGES } from '../constants'

const ExternalRedirect = ({ to }) => {
  if (!to) {
    window.location.assign(PATHS.HOME)
    return null
  }

  window.document.body.innerHTML = ''
  window.location.assign(to)
  return null
}

ExternalRedirect.propTypes = {
  to: PropTypes.string,
}

const routes = {
  HOME: {
    path: PATHS.HOME,
    component: Home,
    exact: true,
  },
  CARE_PLANET: {
    path: PATHS.CARE_PLANET,
    component() {
      const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE
      const currentLanguage = OLD_SHOP_LANGUAGES[document.documentElement.lang]
      const language = currentLanguage || defaultLanguage
      const URL = `${mercadonaDomain}${language}/cuidemos-el-planeta`

      return <ExternalRedirect to={URL} />
    },
    exact: true,
  },
}

export { routes }
